var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { akinon: _vm.akinon, pageMode: _vm.pageMode },
      attrs: { id: "cb-templates" },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex w-100",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _vm.showSideBar
            ? _c(
                "div",
                { staticClass: "side-menubar-wrapper" },
                [
                  _c("SideMenuBar", {
                    attrs: {
                      "selected-page": "templates",
                      "selected-sub-page": "templates",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "_content" }, [
            _vm.showSearch
              ? _c("div", { staticClass: "search-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-container",
                      attrs: { tabindex: "0" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search",
                          },
                        ],
                        attrs: { placeholder: _vm.$t("message.search") },
                        domProps: { value: _vm.search },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("md-icon", [_vm._v("search")]),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "section-templates" }, [
              _vm.showSideBar
                ? _c("div", { staticClass: "section-templates-header" }, [
                    _c(
                      "div",
                      {
                        staticClass: "section-templates-header-text",
                        attrs: {
                          "text-type": "h2",
                          "text-weight": "semi-bold",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.allTemplates")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "template-list" },
                _vm._l(_vm.getFilteredTemplates(), function (item, i) {
                  return _c(
                    "div",
                    {
                      key: item.slug,
                      staticClass: "template-list-item",
                      on: {
                        click: function ($event) {
                          _vm.selectedTemplate = item
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "template-list-item-inner-wrapper" },
                        [
                          _c("div", { staticClass: "block-template" }, [
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", [
                                _vm.akinon || i !== 0
                                  ? _c("div", { staticClass: "icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: item.imageUrl,
                                          alt: "Create " + item.name,
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(item.name[_vm.currentLang])),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "shortDescription" }, [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(
                                        item.shortDescription[_vm.currentLang]
                                      ) +
                                      "\n                                        "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              !_vm.akinon && i === 0
                                ? _c("img", {
                                    staticClass: "image",
                                    attrs: {
                                      src: "/static/img/chatbot/customer-satisfaction-bot.png",
                                    },
                                  })
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      ghost: i !== 0,
                                      disabled: !item.enabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedTemplate = item
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          item.enabled
                                            ? _vm.$t("chatbotv2.importBot")
                                            : _vm.$t("chatbotv2.comingSoon")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.selectedTemplate
        ? _c(
            "a-modal",
            {
              staticClass: "template-modal",
              attrs: {
                centered: "",
                visible: !!_vm.selectedTemplate,
                footer: null,
                closable: true,
              },
              on: {
                cancel: function ($event) {
                  _vm.selectedTemplate = null
                },
              },
            },
            [
              _c("div", { staticClass: "modal-import-template" }, [
                _c("div", { staticClass: "description" }, [
                  _c("div", { staticClass: "top" }, [
                    _c("img", {
                      staticClass: "image",
                      attrs: {
                        src: _vm.selectedTemplate.imageUrl,
                        alt: _vm.selectedTemplate.name,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.selectedTemplate.name[_vm.currentLang]
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              ghost: "",
                              disbled: _vm.importing,
                              loading: _vm.importing,
                              disabled: !_vm.selectedTemplate.enabled,
                            },
                            on: {
                              click: function () {
                                return _vm.createStory(
                                  _vm.selectedTemplate.slug
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.importing
                                    ? _vm.$t("chatbotv2.importing")
                                    : _vm.$t("chatbotv2.importBot")
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tpl-markdown description-content" },
                    [
                      _c("p", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.selectedTemplate.description[
                                _vm.currentLang
                              ].split("\n")[0]
                            ) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.keyFeatures")) + ":"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(
                          _vm.$_.drop(
                            _vm.selectedTemplate.description[
                              _vm.currentLang
                            ].split("\n"),
                            3
                          ),
                          function (keyFeature, index) {
                            return _c("li", { key: index }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(keyFeature.replace("*", "").trim()) +
                                  "\n                        "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "details" }, [
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.lastUpdate"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "data" }, [
                      _vm._v(
                        _vm._s(_vm.timeHumanize(_vm.selectedTemplate.updatedAt))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.categories"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "data",
                        staticStyle: {
                          "flex-direction": "column",
                          "align-items": "flex-start",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.selectedTemplate.categories[
                                _vm.currentLang
                              ].join(", ")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _vm.$i18n.locale === "en" || _vm.$i18n.locale === "ru"
                      ? _c("div", { staticClass: "label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.worksWith")) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "data",
                        staticStyle: {
                          "flex-direction": "column",
                          "align-items": "flex-start",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "display-integrations" },
                          [
                            _c("img", {
                              staticClass: "icon supsis",
                              attrs: { src: "/static/img/supsis-logo3.png" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappV1", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappV2", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappBusinessIcon", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("TelegramIcon"),
                            _vm._v(" "),
                            _c("InstagramIcon", {
                              attrs: { "special-background-mode": "" },
                            }),
                            _vm._v(" "),
                            _c("MessengerIcon"),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$i18n.locale === "tr"
                      ? _c("div", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.worksWith"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }